/*
 * Section actions : premiere action recommandee, ou etapes d'orientation
 * adaptees si la branche prudence sante est active.
 */

import { HeartPulse, Sparkles } from "lucide-react";

const PrudenceSteps = ({ actions }) => (
  <section className="mt-8 rounded-2xl bg-white border border-[rgba(35,82,119,0.14)] p-5 sm:p-6 shadow-[var(--shadow-sm)]" data-testid="bilan-prudence-steps">
    <div className="flex items-center gap-2">
      <HeartPulse className="w-4 h-4 text-[#235277]" aria-hidden="true" />
      <h2 className="font-heading text-base font-semibold text-[#060606]">Tes prochaines étapes adaptées</h2>
    </div>
    <ol className="mt-4 space-y-4" data-testid="bilan-actions-list">
      {actions.map((action, i) => (
        <li key={action} className="flex gap-3 items-start">
          <span className="font-heading shrink-0 w-7 h-7 rounded-full bg-[#235277] text-[#EAFE63] flex items-center justify-center text-xs font-bold">
            {i + 1}
          </span>
          <p className="text-sm leading-relaxed text-[#333333] pt-0.5">{action}</p>
        </li>
      ))}
    </ol>
    <p className="mt-4 text-[11px] text-[#9E9E9E]" data-testid="bilan-prudence-steps-note">
      Ces étapes t’aident à préparer l’échange avec le professionnel de santé qui suit ta
      situation. Elles ne contiennent aucune recommandation sportive ni prescription.
    </p>
  </section>
);

const FirstAction = ({ action }) => (
  <section className="mt-8 rounded-2xl bg-white border border-[rgba(35,82,119,0.14)] p-5 sm:p-6 shadow-[var(--shadow-sm)]" data-testid="bilan-first-action">
    <div className="flex items-center gap-2">
      <Sparkles className="w-4 h-4 text-[#235277]" aria-hidden="true" />
      <h2 className="font-heading text-base font-semibold text-[#060606]">Ta première action</h2>
    </div>
    <div className="mt-4 flex gap-3 items-start rounded-xl bg-[#E2F6FF] border border-[rgba(35,82,119,0.16)] p-4">
      <span className="font-heading shrink-0 w-7 h-7 rounded-full bg-[#235277] text-[#EAFE63] flex items-center justify-center text-xs font-bold">1</span>
      <p className="text-sm leading-relaxed text-[#0B2B44] pt-0.5" data-testid="bilan-first-action-text">{action}</p>
    </div>
    <p className="mt-4 text-[11px] text-[#9E9E9E]">
      Action issue d’une bibliothèque validée, sans prescription médicale ni supplémentation.
    </p>
  </section>
);

export const ActionsSection = ({ medicalCaution, actions, firstAction }) => {
  if (medicalCaution) return <PrudenceSteps actions={actions} />;
  if (!firstAction) return null;
  return <FirstAction action={firstAction} />;
};
